import { ProspectQueryParameters } from '@quorum/models/xs-query';

const MULTI_VALUE_KEYS: Array<'employeeId' | 'channelId' | 'sourceId'> = ['employeeId', 'channelId', 'sourceId'];

/**
 * Normalises multi-select prospect filters for the prospects endpoint, which expects a single
 * comma-separated value per param. Sending them as arrays serialises to repeated query keys
 * (`sourceId=a&sourceId=b...`), which fails once there are more than ~20 values (see XS-10577 /
 * XS-11331). An empty array is omitted entirely — an empty `channelId=` / `sourceId=` breaks the
 * API result set, so it must not be sent at all.
 *
 * statusId / typeId are intentionally left as arrays: they are fixed, small option sets.
 */
export function normalizeMultiSelectParams(params: ProspectQueryParameters): ProspectQueryParameters {
  const normalized: ProspectQueryParameters = { ...params };

  MULTI_VALUE_KEYS.forEach((key) => {
    const value = normalized[key];
    if (Array.isArray(value)) {
      if (value.length === 0) {
        delete normalized[key];
      } else {
        normalized[key] = value.join(',');
      }
    }
  });

  return normalized;
}
